// import React from "react";
// import { Link } from "react-router-dom";
// import CTABanner from "./CTABanner";

// const HeroSection = () => (
//   <>
//     <section className="relative flex items-center justify-center min-h-[90vh] py-16 overflow-hidden bg-[#0d2835]">
//       <div className="absolute inset-0 z-0">
//         <img
//           src="/images/hero-banner-img.jpg"
//           className="w-full h-[400px] object-cover md:h-full "
//         />
//         {/* <video
//           autoPlay
//           loop
//           muted
//           playsInline
//           className="absolute top-0 left-0 w-full h-full object-cover opacity-90"
//         >
//           <source src="/videos/hero-video.mp4" type="video/mp4" />
//         </video> */}
//         <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70 z-10"></div>
//       </div>

//       {/* Main Content */}
//       <div className="relative z-20 text-center px-6 sm:px-8 lg:px-10 max-w-6xl mx-auto">
//         {/* Headline with Improved Typography */}
//         <div className="mb-12">
//           <div className="inline-flex items-center bg-[#4FA0FF]/90 px-4 py-2 rounded-full mb-6 border border-[#4FA0FF]">
//             <span className="text-white text-sm font-medium">
//               SALARY ADVANCE LOANS
//             </span>
//           </div>
//           <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
//             <span className="block mb-1 md:mb-3">
//               Instant Salary-Based Loans,
//             </span>
//             <span className="text-[#4FA0FF] bg-clip-text bg-gradient-to-r from-[#4FA0FF] to-[#3B8FE8]">
//               Anytime You Need!
//             </span>
//           </h1>

//           <p className="text-lg sm:text-xl text-blue-100 mb-10 max-w-3xl mx-auto leading-relaxed">
//             Kubermax provides quick and reliable short-term loans
//             tailored for salaried employees. Enjoy a fully digital process with
//             minimal documentation and instant disbursal.
//           </p>
//         </div>

//         {/* Features Grid - Premium Design */}
//         <div className="flex justify-center  flex-wrap gap-4 md:flex mb-14 max-w-5xl mx-auto">
//           {[
//             {
//               icon: (
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M5 13l4 4L19 7"
//                 />
//               ),
//               title: "Instant Approval",
//               desc: "Get approved in minutes",
//             },
//             {
//               icon: (
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                 />
//               ),
//               title: "100% Online",
//               desc: "Complete digital process",
//             },
//             {
//               icon: (
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//                 />
//               ),
//               title: "For Salaried Pros",
//               desc: "Tailored for professionals",
//             },
//           ].map((item, index) => (
//             <div
//               key={index}
//               className="flex gap-5 sm:flex-col md:gap-4 items-center justify-center bg-white/5 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/10"
//             >
//               <div className="bg-[#4FA0FF] rounded-lg p-3 w-12 h-12 flex items-center">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-6 w-6 text-white"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   {item.icon}
//                 </svg>
//               </div>
//               <div className="text-left sm:text-center">
//                 <h3 className="text-xl font-bold text-white mb-2">
//                   {item.title}
//                 </h3>
//                 <p className="text-blue-100 text-sm">{item.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="flex flex-col sm:flex-row gap-4 justify-center">
//           <Link
//             to="/apply-now"
//             className="flex items-center justify-center bg-[#FFD700] text-[#1D3557] font-bold py-4 px-10 rounded-lg text-xl shadow-md  hover:-translate-y-1 group transition-all duration-200"
//           >
//             <span>Apply Now</span>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-all duration-200"
//               viewBox="0 0 20 20"
//               fill="currentColor"
//             >
//               <path
//                 fillRule="evenodd"
//                 d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
//                 clipRule="evenodd"
//               />
//             </svg>
//           </Link>
//           <Link
//             to="#learn-more"
//             className="bg-[#4FA0FF] hover:-translate-y-1 text-[#fff] font-bold py-4 px-10 rounded-lg text-xl shadow-md transition-all duration-200 flex items-center justify-center"
//           >
//             <span>Learn More</span>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-5 w-5 ml-2"
//               viewBox="0 0 20 20"
//               fill="currentColor"
//             >
//               <path
//                 fillRule="evenodd"
//                 d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
//                 clipRule="evenodd"
//               />
//             </svg>
//           </Link>
//         </div>
//       </div>
//     </section>

//     {/* Enhanced CTA Banner */}
//     <CTABanner />
//   </>
// );

// export default HeroSection;
// import React from "react";
// import { Link } from "react-router-dom";
// import CTABanner from "./CTABanner";

// const HeroSection = () => (
//   <>
//     {/* Background */}
//     <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#eef7ff] via-white to-[#dbe9ff] overflow-hidden">
//       <div className="absolute w-[600px] h-[600px] bg-[#4FA0FF]/20 blur-[100px] rounded-full top-[-100px] right-[-100px] animate-slowfloat"></div>
//       <div className="absolute w-[400px] h-[400px] bg-[#7dd3fc]/30 blur-[120px] rounded-full bottom-[-80px] left-[-80px] animate-slowfloat2"></div>
//     </div>

//     {/* MAIN HERO WRAPPER */}
//     <section className="relative min-h-[90vh] w-full pt-24 px-6 md:px-12 lg:px-20">

//       {/* PARENT WRAPPER (LEFT + RIGHT) */}
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

//         {/* LEFT SIDE */}
//         <div className="flex flex-col gap-6 animate-slide-up">

//           {/* Tag */}
//           <div className="inline-flex w-fit items-center bg-white/70 backdrop-blur-xl px-4 py-2 rounded-full border border-[#4FA0FF]/10 shadow-sm">
//             <span className="text-[#4FA0FF] text-sm font-semibold tracking-wide">
//               INSTANT SALARY LOANS
//             </span>
//           </div>

//           {/* Title */}
//           <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#0c1a2c] leading-tight">
//             Your Salary,
//             <span className="text-[#4FA0FF] bg-clip-text bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5]">
//               {" "}
//               Your Instant Loan
//             </span>
//             <br /> Within Minutes.
//           </h1>

//           <p className="text-lg md:text-xl text-[#234066] opacity-90 leading-relaxed">
//             100% digital, fast approval & secure processing. Get quick funds
//             directly into your bank account.
//           </p>

//           {/* Buttons */}
//           <div className="flex flex-col sm:flex-row gap-4 -mt-2">
//             <Link
//               to="/apply-now"
//               className="px-8 py-4 rounded-xl text-white font-bold shadow-lg hover:scale-105 transition-all bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] text-center"
//             >
//               Apply Now
//             </Link>

//             <Link
//               to="#learn"
//               className="px-8 py-4 rounded-xl font-bold shadow-md hover:scale-105 transition-all bg-white/60 backdrop-blur-xl border border-[#4FA0FF]/30 text-[#1d3557] text-center"
//             >
//               Learn More
//             </Link>
//           </div>
//         </div>

//         {/* RIGHT: VIDEO */}
//         <div className="flex justify-center md:justify-end animate-slide-up-slow w-full">

//           <div className="rounded-2xl overflow-hidden shadow-2xl border border-white/40 bg-white/30 backdrop-blur-xl w-[300px] sm:w-[350px] md:w-[400px] lg:w-[460px]">
//             <video
//               autoPlay
//               loop
//               muted
//               playsInline
//               className="w-full h-full object-cover rounded"
//             >
//               <source src="/videos/herosection.mp4" type="video/mp4" />
//             </video>
//           </div>

//         </div>

//       </div>
//     </section>

//     <CTABanner />
//   </>
// );

// export default HeroSection;


// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import CTABanner from "./CTABanner";

// const sliderImages = [
//   "/images/content_banner.jpg",
//   "/images/hero-banner-img.jpg",
//   "/images/herosectionslider1.jpg",
// ];

// const HeroSection = () => {
//   const [current, setCurrent] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrent((prev) => (prev + 1) % sliderImages.length);
//     }, 4000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <>
//       {/* ⭐ HERO SECTION WITH SLIDER */}
//       <section className="relative w-full h-[90vh] flex items-center justify-center overflow-hidden">

//         {/* ⭐ Background Slider */}
//         <div className="absolute inset-0 -z-10">
//           {sliderImages.map((img, index) => (
//             <img
//               key={index}
//               src={img}
//               className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms]
//                 ${index === current ? "opacity-100" : "opacity-0"}
//               `}
//               alt="slide"
//             />
//           ))}

//           {/* Gradient Overlay 🟦 */}
//           <div className="absolute inset-0 bg-[#0c1a2c]/50"></div>
//         </div>

//         {/* ⭐ Hero Text Content */}
//         <div className="relative z-10 px-6 text-center max-w-3xl animate-slide-up">
//           {/* Tag */}
//           <div className="inline-flex bg-white/30 backdrop-blur-xl px-5 py-2 rounded-full border border-white/20 mb-4">
//             <span className="text-white font-semibold tracking-wide">
//               INSTANT SALARY LOANS
//             </span>
//           </div>

//           {/* Title */}
//           <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight">
//             Your Salary,
//             <span className="text-[#4FA0FF]"> Your Instant Loan</span>
//             <br /> Within Minutes.
//           </h1>

//           {/* Subtitle */}
//           <p className="text-lg md:text-xl text-white/90 mt-4">
//             Quick approval. 100% digital. Funds directly in your bank account.
//           </p>

//           {/* Buttons */}
//           <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
//             <Link
//               to="/apply-now"
//               className="px-8 py-4 rounded-xl text-white font-bold shadow-lg bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] hover:scale-105 transition-all"
//             >
//               Apply Now
//             </Link>

//             <Link
//               to="#learn"
//               className="px-8 py-4 rounded-xl font-bold bg-white/40 backdrop-blur-xl text-white border border-white/30 hover:scale-105 transition-all"
//             >
//               Learn More
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* ⭐ CTABanner Added Back */}
//       <CTABanner />
//     </>
//   );
// };

// export default HeroSection;
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CTABanner from "./CTABanner";

const slides = [
  {
    img: "/images/herosectionslider3.jpg",
    title: "Get Instant Salary Support",
    highlight: "With Zero Hassle",
    subtitle: "Fast approval, paperless & secure — support in minutes.",
  },
  {
    img: "/images/herosectionslider2.jpg",
    title: "Smart Solutions",
    highlight: "For Smart Employees",
    subtitle: "Designed for working professionals needing quick financial flexibility.",
  },
  {
    img: "/images/herosectionslider1.jpg",
    title: "Your Salary,",
    highlight: "Your Power",
    subtitle: "Unlock instant financial support whenever you need it.",
  },
];

const HeroSection = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* HERO SECTION */}
      <section className="relative w-full h-[105vh] flex items-center justify-center overflow-hidden">

        {/* Background Slider */}
        <div className="absolute inset-0 -z-10">
          {slides.map((slide, index) => (
            <img
              key={index}
              src={slide.img}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms]
                ${index === current ? "opacity-100" : "opacity-0"}
              `}
              alt="slide"
            />
          ))}

          {/* Overlay */}
          <div className="absolute inset-0 bg-[#000]/45"></div>
        </div>

        {/* Text */}
        <div
          key={current}
          className="relative z-10 px-6 py-8 text-center max-w-3xl animate-fade-up"
        >
          {/* Tag */}
          <div className="inline-flex bg-white/20 backdrop-blur-xl px-5 py-2 rounded-full border border-white/20 mb-4 shadow-md">
            <span className="text-white font-semibold tracking-wide">
              INSTANT SALARY SUPPORT
            </span>
          </div>

          {/* TITLE */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight drop-shadow-xl">
            {slides[current].title}{" "}
            <span className="text-[#1d8df5] drop-shadow-xl">
              {slides[current].highlight}
            </span>
          </h1>

          {/* SUBTITLE */}
          <p className="text-lg md:text-xl text-[#E2F3FF] mt-4 drop-shadow-md">
            {slides[current].subtitle}
          </p>

          {/* BUTTONS */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
            <Link
              to="/apply-now"
              className="px-8 py-3 rounded-xl text-white font-bold shadow-lg bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] hover:bg-[#0766A6] hover:scale-105 transition-all"
            >
              Get Started
            </Link>

            <Link
              to="#learn"
              className="px-8 py-4 rounded-xl font-bold bg-white/20 backdrop-blur-xl text-white border border-white/30 hover:scale-105 transition-all"
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>

      <CTABanner />
    </>
  );
};

export default HeroSection;